export default "__VITE_ASSET__BSgn9hCA__"